export default __webpack_public_path__ + "static/media/rasm1.8bec2eda.jpg";